import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import cx from 'classnames2';
import React, { Component } from 'react';
import styles from './StaticColumnHeader.scss';
export var StaticColumnHeader = /*#__PURE__*/function (_Component) {
  _inherits(StaticColumnHeader, _Component);

  var _super = _createSuper(StaticColumnHeader);

  function StaticColumnHeader(props) {
    var _this;

    _classCallCheck(this, StaticColumnHeader);

    _this = _super.call(this, props); // this is required to make the parent container expand itself to fit the entire column

    props.reactContainer.style.display = 'inline';
    props.reactContainer.style.flex = 1;
    return _this;
  }

  _createClass(StaticColumnHeader, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: cx(styles.base, this.props.highlight && styles.highlight),
        role: "columnheader"
      }, React.createElement("div", {
        className: cx(styles.headerCell, this.props.alignRight ? styles.value : styles.text)
      }, this.props.displayName));
    }
  }]);

  return StaticColumnHeader;
}(Component);